export const useGetUrlsFromPostText = (text: string): string[] | null => {
	const urlsTextRegex = new RegExp(
		"(?:(?:https?|ftp|file)://|www.|ftp.)(?:([-A-Z0-9+&@#/%=~_|$?!:,.]*)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:([-A-Z0-9+&@#/%=~_|$?!:,.]*)|[A-Z0-9+&@#/%=~_|$])",
		"gim",
	);
	const instances = text.match(urlsTextRegex);

	return instances;
};
